import { useSelector } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { claimState } from '../../state/state';
import { blankTaskTemplate } from '../../templates/state/state';

const useTaskFieldList = ({ section }) => {
  const { role } = useSelector((state) => state.auth);
  const { activeTask: task, templates } = useSelector((state) => state.requests.tasks);
  const template = findResult(templates, 'open', task.formKey) || blankTaskTemplate();
  return {
    canEdit: claimState(task, role).canEdit,
    fields: template.sections[section].fields,
    task,
    template,
  };
};

export default {
  useTaskFieldList,
};
